import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import type BankTransferDetailViewModel from "viewModels/finance/outgoingPayments/bankTransferDetailViewModel";
import { observer } from "mobx-react-lite";
import Section from "views/common/section";
import { Col, Form } from "react-bootstrap";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { formatBankAccount } from "@edaz/utils/bankAccount";
import { formatDate, translateEnum } from "utils/localizations";
import { emptyValue } from "utils/emptyValue";

const OriginalBankTransferPaymentSection: ViewComponent<BankTransferDetailViewModel> = observer(({ vm }) => {
  const originalPayment = vm.item.originalPayment;
  const originalTransferPayment = originalPayment?.originalTransferPayment;
  const originalPayGatePayment = originalPayment?.originalPayGatePayment;
  let content = null;

  if (originalTransferPayment) {
    content = (
      <>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("transferOriginalPaymentDetailResponse", "postingDate")}</Form.Label>
          <FakeInput target={originalTransferPayment} property="postingDate" valueFormatter={formatDate} />
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>{vm.translateSubAttribute("transferOriginalPaymentDetailResponse", "senderBankAccount")}</Form.Label>
          <FakeInput
            target={originalTransferPayment}
            property="senderBankAccount"
            valueFormatter={value => formatBankAccount(value)}
          />
        </Form.Group>
      </>
    );
  } else if (originalPayGatePayment) {
    content = (
      <>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("originalPayGatePaymentResponse", "authorizedAt")}</Form.Label>
          <FakeInput target={originalPayGatePayment} property="authorizedAt" valueFormatter={formatDate} />
        </Form.Group>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("originalPayGatePaymentResponse", "cardNumber")}</Form.Label>
          <FakeInput target={originalPayGatePayment} property="cardNumber" />
        </Form.Group>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("originalPayGatePaymentResponse", "arn")}</Form.Label>
          <FakeInput target={originalPayGatePayment} property="arn" />
        </Form.Group>
      </>
    );
  }

  return (
    <Section title={vm.translate("originalPayment")} context={originalPayment}>
      <Form.Row>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("outgoingTransferOriginalPaymentResponse", "sourceType")}</Form.Label>
          <FakeInput
            target={originalPayment}
            property="sourceType"
            valueFormatter={value => (value ? translateEnum("sourceType", value) : emptyValue)}
          />
        </Form.Group>
        {content}
      </Form.Row>
    </Section>
  );
});

export default OriginalBankTransferPaymentSection;
